import { NgbPaginationNumber } from "@ng-bootstrap/ng-bootstrap";
import { Emisor } from "../Emisor/Emisor";
import { GuiaDespacho } from "../GuiaDespacho";
import { Proveedor } from "../Proveedor/Proveedor";
import { Receptor } from "../Receptor/Receptor";
import { ComisionRecargo } from "./ComisionRecargo";
import { DescuentoRecargo } from "./DescuentoRecargo";
import { DetalleDte } from "./DetalleDte";
import { FacturaExportacion } from "./FacturaExportacion";
import { IDte } from "./IDte";
import { OtraMoneda } from "./OtraMoneda";
import { ReferenciaDte } from "./ReferenciaDte";
import { ReferenciaDteEmitido } from "./ReferenciaDteEmitido";
import { DetalleDteImpuestoAdicional } from "./DetalleDteImpuestoAdicional";
import { NotaDebito } from "../NotaDebito";
import { NotaCredito } from "../NotaCredito";

export class DteEmitido {
	dteId: string;
	receptorId: string;
	clienteId?: string;
	rutReceptor: string;
	emisorId: string;
	tipoDteId: string;
	codigoTipoDte: number;
	sucursalId: string;
	nombreSucursal: string;
	folio: number;
	fecha: Date;
	fechaCreacion: Date;
	estadoSii: number;
	estadoSiiDescripcion?: string;
	trackId: number;
	xmlString: string;
	formaPago: string;
	formaPagoEnum: number;
	FormaPagoExportacion: string;
	FormaPagoExportacionEnum?: number;
	archivoExcelId: string;
	importacionMasivaId: string;
	neto: number;
	iva: number;
	exento: number;
	total: number;
	impuestos: number;
	fechaProcesamiento: Date;
	consumoFolioId: string;
	detalleDte: Array<DetalleDte>;
	emisorAsociado: Emisor;
	nombreTipoDte: string;
	razonSocial: string;
	receptorAsociado: Receptor;
	receptorEnt: Receptor;
	anulado: boolean;
	importado: boolean;
	rutReceptorDv: string;
	fechaVencimiento: Date;
	//campos de referencias dte
	fechaDteReferenciado: Date;
	razonReferencia: string;
	rutEmisor: number;
	codigoTipoDteReferencia: string;
	folioReferencia: string;
	fechaReferencia: Date;
	codigoRazonReferencia: number;
	listaReferencias: ReferenciaDte[];
	listaReferenciasDteEmitido: ReferenciaDteEmitido[];
	listaReferenciasGuia?: ReferenciaDteEmitido[];
	reutilizarFoliohabilitado: boolean;
	notaDebito: NotaDebito;
	notaCredito: NotaCredito;
	//tipo de moneda
	tipoMoneda: string;
	descuentoGlobal: number;
	formato: number;
	diasVencimiento: number;
	otraMonedaEnt: OtraMoneda;
	DescuentoRecargoEnts: DescuentoRecargo[];
	notaCreditoHabilitada: boolean;
	notaDebitoHabilitada: boolean;
	indicadorServicio: number;
	indicadorMontosNetos: boolean;
	guiaDespacho: GuiaDespacho;
	proveedor: Proveedor;
	comisionesCargosDte: ComisionRecargo[];
	comisionCargo: number;
	dteExportacionEnt: FacturaExportacion;
	cesionHabilitada: boolean;
	cedibleHabilitado: boolean;
	tieneIvaTerceros: boolean;
	ivaTerceros: number;
	ivaPropio: number;
	negativa: boolean;
	tipoMonedaAduana: string;
	codigoMonedaAduana: number;
	folioReutilizado: boolean;
	estadoAcuse: number;
	descripcionEstadoAcuse: string;
	documentosLiquidados: string[];
	guiasFacturadas: string[];
	facturado: boolean;
	observaciones: string;
	tipoPago: string;
	impuestosDesglosados: DetalleDteImpuestoAdicional[];
	showActions?: boolean;
	pdfUrl?:string;
	generatePDFUrl?:string;
	dtePagado?:boolean;
}
